import React from 'react'
import {Field, ErrorMessage} from 'formik'

const FormField = ({name, type = `text`, placeholder}) => {
  return (
    <div className={`form-item`}>
      <Field
        name={name}
        type={type}
        placeholder={placeholder}
        className={`form-field`}
      />
      <ErrorMessage
        name={name}
        component={`div`}
        className={`form-field-error`}
      />
    </div>
  )
}

export default FormField